/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import { Overlay } from 'react-bootstrap';
import PropTypes from 'prop-types';
import CopyToClipboard from 'react-copy-to-clipboard';
import CustomOverlayAwareTooltip from './CustomOverlayAwareTooltip';

class CopyComponent extends React.Component {
  constructor(props) {
    super(props);
    this.copyIconRef = React.createRef();
    this.getTarget = this.getTarget.bind(this);
  }

  getTarget() {
    return this.copyIconRef.current;
  }

  handleKeyDown = (event) => {
    // Handle Enter and Space keys for accessibility
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.props.handleClick();
      navigator.clipboard.writeText(this.props.text);
    }
  };

  render() {
    const {
      text, className, dtmTagName, toolTipHoverText, toolTipClickText, iconClass, handleClick, showToolTip
    } = this.props;

    return (
      <CopyToClipboard text={text}>
        <div
          data-testid="Copy-Component"
          style={{ display: 'inline-block', cursor: 'pointer' }}
          tabIndex="0"
          role="button"
          aria-label={toolTipHoverText}
          onKeyDown={this.handleKeyDown}
          onClick={handleClick}
        >
          <div
            className={className}
            data-dtm={dtmTagName}
            ref={this.copyIconRef}
            title={toolTipHoverText}
            aria-hidden="true"
          />
          <Overlay
            target={this.getTarget}
            show={showToolTip}
            placement="left"
          >
            <CustomOverlayAwareTooltip message={toolTipClickText} iconClass={iconClass} />
          </Overlay>
        </div>
      </CopyToClipboard>
    );
  }
}

CopyComponent.propTypes = {
  text: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
  dtmTagName: PropTypes.string,
  toolTipHoverText: PropTypes.string.isRequired,
  toolTipClickText: PropTypes.string.isRequired,
  iconClass: PropTypes.string.isRequired,
  handleClick: PropTypes.func.isRequired,
  showToolTip: PropTypes.bool.isRequired
};

export default CopyComponent;
